import { render } from "./CardEditSubheader.vue?vue&type=template&id=1211032f&scoped=true"
import script from "./CardEditSubheader.vue?vue&type=script&lang=js"
export * from "./CardEditSubheader.vue?vue&type=script&lang=js"

import "./CardEditSubheader.vue?vue&type=style&index=0&id=1211032f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1211032f"]])

export default __exports__